module.exports = __webpack_public_path__ + "img/DKDK CHI TIET CHUONG TRINH UU DAI DAC QUYEN THE TIN DỤNG HAPPY GOLF 12.07.2023-hình ảnh-6.78841a91.jpg";